{
  "name": "frontend",
  "version": "1.6.8",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:uat": "ng serve --configuration uat",
    "build": "ng build",
    "build:uat": "ng build --configuration uat",
    "build:prod": "ng build --configuration production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "packageManager": "npm@11.6.2",
  "dependencies": {
    "@angular/common": "^21.1.0",
    "@angular/compiler": "^21.1.0",
    "@angular/core": "^21.1.0",
    "@angular/forms": "^21.1.0",
    "@angular/platform-browser": "^21.1.0",
    "@angular/router": "^21.1.0",
    "@primeuix/themes": "^2.0.3",
    "chart.js": "^4.5.1",
    "exceljs": "^4.4.0",
    "lucide-angular": "^1.0.0",
    "primeng": "^21.1.9",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular/build": "^21.1.2",
    "@angular/cli": "^21.1.2",
    "@angular/compiler-cli": "^21.1.0",
    "@tailwindcss/postcss": "^4.3.3",
    "postcss": "^8.5.26",
    "tailwindcss": "^4.3.3",
    "typescript": "~5.9.2"
  }
}
